export default "__VITE_ASSET__BxIfPSnn__"